import { HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { AbstractApiService } from '@core/abstract-classes/abstract-api-service';
import { DictionaryModel } from '@core/interfaces/dictionary.model';
import { PackagePriceHistoryResponse } from '@core/interfaces/price-history.model';
import { ResponseModel } from '@core/interfaces/response.model';
import { TableSettings } from '@core/interfaces/table-settings.model';
import { DrugsItemDetailInterface, DrugsItemInterface } from '@store/drugs/drugs-item.inteface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ApiDrugsService extends AbstractApiService {
    constructor(injector: Injector) {
        super(injector);
    }

    public getDrugsList(params: TableSettings<string>): Observable<ResponseModel<DrugsItemInterface>> {
        return this.reqGet<ResponseModel<DrugsItemInterface>>(params, 'Medicines');
    }

    public getDrugsAnaloguesList(params: TableSettings<string>): Observable<ResponseModel<DrugsItemInterface>> {
        return this.reqGet<ResponseModel<DrugsItemInterface>>(params, 'Medicines/analogues');
    }

    public getDrugsAnaloguesListWithPrice(params: TableSettings<string>): Observable<ResponseModel<DrugsItemInterface>> {
        return this.reqGet<ResponseModel<DrugsItemInterface>>(params, 'Medicines/analogues-with-minimum-price');
    }

    public getDrugsAnaloguesListWithPriceByTradeName(params: TableSettings<string>): Observable<ResponseModel<DrugsItemInterface>> {
        return this.reqGet<ResponseModel<DrugsItemInterface>>(params, 'Medicines/analogues-with-minimum-price-by-trade-name');
    }

    public getDrugsByMaskList(params: TableSettings<string>): Observable<ResponseModel<DrugsItemInterface>> {
        return this.reqGet<ResponseModel<DrugsItemInterface>>(params, 'Medicines/by-mask');
    }

    public getDrugById(id: string): Observable<DrugsItemDetailInterface> {
        return this.reqGet<DrugsItemDetailInterface>({}, `Medicines/${id}`);
    }

    public getReleaseForm(): Observable<DictionaryModel<string, string>[]> {
        return this.reqGet<DictionaryModel<string, string>[]>({}, 'ReleaseForm');
    }

    public exportCatalog(): Observable<HttpResponse<Blob>> {
        return this.reqGetFile(null, 'Medicines/export-in-excel');
    }

    public getPackagePriceHistory(pcid: string): Observable<PackagePriceHistoryResponse> {
        return this.reqGet<PackagePriceHistoryResponse>({}, `Medicines/${pcid}/price-history`);
    }
}
